export default __webpack_public_path__ + "phone.9a2eb5a9.png";